import React from 'react';
import getMoment from '../utils/getMoment';
import getMomentTimeZone from '../utils/getMomentTimeZone';
import Label from '../utils/label';
import Config from '../utils/config';
import * as Cookie from '../utils/cookie';

const IUserName = Config.appConfig.IUserName;

class UMPopup extends React.PureComponent {

	static displayName = 'UMPopup';
	
	state = {
		open: false,
		startTime: '0000-00-00 00:00',
		endTime: '0000-00-00 00:00'
	};

	UMPopupRef = React.createRef();

	handleUMPopup = async event => {
		const { UMCheck, StartTime, EndTime } = event.detail;

		// 目前沒有 UM
		if (UMCheck === 0) {
			Cookie.deleteCookie(`UM5Mins_${IUserName}`);
			Cookie.deleteCookie(`UM30Mins_${IUserName}`);
			return;
		}
		await getMoment();
		const moment = await getMomentTimeZone();
		const now = moment();
		const start = moment(StartTime);
		const end = moment(EndTime);

		// 如果 UM 時間突然跟改，則刪除 cookie(把表示已顯示的紀錄刪除)
		const { StartTime: startTimeFromCookie, EndTime: endTimeFromCookie } = JSON.parse(Cookie.getCookie('UM_Time')) || {};
		if (!start.isSame(startTimeFromCookie) || !end.isSame(endTimeFromCookie)) {
			Cookie.deleteCookie(`UM5Mins_${IUserName}`);
			Cookie.deleteCookie(`UM30Mins_${IUserName}`);
		}

		const fiveMinsBeforeStart = start.clone().subtract(5, 'minutes');
		const thirtyMinsBeforeStart = start.clone().subtract(30, 'minutes');

		//開始前 5 分鐘，而且之前沒 show 過 5 分鐘前提醒
		if (now.isBetween(fiveMinsBeforeStart, start) && !Cookie.getCookie(`UM5Mins_${IUserName}`)) {
			this.open(
				start.tz(moment.tz.guess()).format('h:mm A'),
				end.tz(moment.tz.guess()).format('h:mm A')
			);
			Cookie.setCookie(`UM5Mins_${IUserName}`, true, 1);
			Cookie.setCookie('UM_Time', JSON.stringify({ StartTime, EndTime }), 1);
		}

		//開始前 5~30 分鐘，而且之前沒 show 過 5~30 分鐘前提醒
		else if (now.isBetween(thirtyMinsBeforeStart, fiveMinsBeforeStart) && !Cookie.getCookie(`UM30Mins_${IUserName}`)) {
			this.open(
				start.tz(moment.tz.guess()).format('h:mm A'),
				end.tz(moment.tz.guess()).format('h:mm A')
			);
			Cookie.setCookie(`UM30Mins_${IUserName}`, true, 1);
			Cookie.setCookie('UM_Time', JSON.stringify({ StartTime, EndTime }), 1);
		}
	};

	open = (start, end) => {
		this.setState({
			open: true,
			startTime: start,
			endTime: end
		}, this.closeAfter15Seconds);
	};

	close = () => {
		this.setState({ open: false });
	};

	closeAfter15Seconds = () => {
		setTimeout(() => {
			this.setState({ open: false });
		}, 15 * 1000);
	};
	
	componentDidMount() {
		const umTime = this.UMPopupRef.current;
		umTime.addEventListener('um-time', this.handleUMPopup);
	}

	componentWillUnmount() {
		const umTime = this.UMPopupRef.current;
		umTime.removeEventListener('um-time', this.handleUMPopup);
	}

	render() {
		const startTime = this.state.startTime;
		const endTime = this.state.endTime;
		const msgHTML = Label.UM_notification.replace('{0}', startTime.bold()).replace('{1}', endTime.bold());

		return (
			<div id="UMPopup" className="um-popup" data-tag="tagMsgUM" ref={this.UMPopupRef} >
				{this.state.open && (
					<div className="um-popup-content">
						<div className="icon-history" />
						<div className="msgText" dangerouslySetInnerHTML={{__html: msgHTML}} />
						<div className="icon-close" onClick={this.close} />
					</div>
				)}
			</div>
		);
	}
}

export default UMPopup;
